var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('div',[_c('div',{staticClass:"main-icon-container-wrapper"},[_c('div',{staticClass:"icon-container"},[_c('i',{staticClass:"fa-solid fa-shopping-basket"})])])])])
}]

export { render, staticRenderFns }